import React, { Component } from 'react';
import { get, isEmpty, omitBy } from 'lodash';
import MapContainer from '../Map';
import ProviderList from '../ProviderList';
import Search from '../Search';
import ProviderModal from '../ProviderModal';
import {
  fetchBootstrap,
  fetchProviders,
  fetchServiceTypes,
} from '../../actions';
import { getResultBounds, dispatchEvent } from '../../utils';

class SearchWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bootstrap: {},
      google: null,
      hasSearched: false,
      hoveredCard: null,
      loading: true,
      map: null,
      mapBounds: null,
      mapCenter: {},
      paging: {},
      providers: [],
      selectedProvider: {},
      serviceTypes: [],
      showAdvancedFilters: false,
      showInfoWindow: false,
      showModal: false,
    };

    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onInfoWindowClose = this.onInfoWindowClose.bind(this);
    this.onCardClick = this.onCardClick.bind(this);
    this.onCardMouseEnter = this.onCardMouseEnter.bind(this);
    this.onCardMouseLeave = this.onCardMouseLeave.bind(this);
    this.onSearchSubmit = this.onSearchSubmit.bind(this);
    this.onToggleAdvancedFilters = this.onToggleAdvancedFilters.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onMapCenterChange = this.onMapCenterChange.bind(this);
    this.onMapReady = this.onMapReady.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });

    const promises = [
      fetchBootstrap(),
      fetchServiceTypes(),
    ];

    return Promise.all(promises).then((responses) => {
      this.setState({
        loading: false,
        bootstrap: get(responses, '[0].data', {}),
        serviceTypes: get(responses, '[1].data', []),
      }, () => {
        dispatchEvent('onUUSearchReady');
      });
      return responses;
    });
  }

  onMarkerClick(place) {
    this.setState({
      selectedProvider: get(place, 'provider', {}),
      showInfoWindow: true,
    }, () => dispatchEvent('onUUMarckerClick'));
  }

  onMapCenterChange(mapProps, map) {
    const center = map.getCenter().toJSON();
    this.setState({
      mapCenter: center,
    });
  }

  onMapReady(mapProps, map) {
    this.setState({
      google: mapProps.google,
      map,
    }, () => dispatchEvent('onUUMapReady'));
    this.onMapCenterChange(mapProps, map);
  }

  onInfoWindowClose() {
    this.setState({
      selectedProvider: {},
      showInfoWindow: false,
    }, () => dispatchEvent('onUUInfoWindowClose'));
  }

  onCardClick(provider) {
    this.setState({
      selectedProvider: provider,
      showInfoWindow: false,
      showModal: true,
    }, () => dispatchEvent('onUUCardClick'));
  }

  onCardMouseEnter(provider) {
    this.setState({
      hoveredCard: provider,
    });
  }

  onCardMouseLeave() {
    this.setState({
      hoveredCard: null,
    });
  }

  onToggleAdvancedFilters() {
    const { showAdvancedFilters } = this.state;
    this.setState({
      showAdvancedFilters: !showAdvancedFilters,
    }, () => dispatchEvent(showAdvancedFilters ? 'onUUFiltersClose' : 'onUUFiltersOpen'));
  }

  onSearchSubmit(values) {
    const { mapCenter, google } = this.state;
    const { mapBounds } = this.state;
    const searchParams = {
      text: values.searchTerm,
      service_type_ids: isEmpty(values.serviceType) ? [] : [values.serviceType],
      restricted_to: values.restricted_to,
      accessibility_options: values.accessibility_options,
      languages: values.languages,
      states: values.states,
      counties: values.counties,
      places: values.places,
      distance: values.distance === 'any' ? '' : values.distance,
      coordinates: {
        lat: mapCenter.lat,
        lon: mapCenter.lng,
      },
    };
    dispatchEvent('onUUSearch');
    fetchProviders(omitBy(searchParams, isEmpty)).then((response) => {
      const providers = response.data;
      const newBounds = getResultBounds(providers, null, google);
      this.setState({
        providers,
        paging: response.paging,
        mapBounds: newBounds || mapBounds,
        hasSearched: true,
      });
      return response;
    });
  }

  onModalClose() {
    this.setState({ showModal: false }, () => dispatchEvent('onUUModalClose'));
  }

  render() {
    const {
      bootstrap,
      google,
      hasSearched,
      hoveredCard,
      loading,
      map,
      mapBounds,
      paging,
      providers,
      selectedProvider,
      serviceTypes,
      showAdvancedFilters,
      showInfoWindow,
      showModal,
    } = this.state;

    if (loading) {
      return null;
    }

    const apiKey = get(window, 'uuSearchSettings.google-map-api-key');
    if (!apiKey) {
      return null;
    }
    const wrappserClass = `uu-search-wrapper ${showAdvancedFilters ? 'uu-search-wrapper--advanced-filters' : ''}`;

    return (
      <div className={wrappserClass}>
        <MapContainer
          apiKey={apiKey}
          hoveredCard={hoveredCard}
          mapBounds={mapBounds}
          onInfoWindowClose={this.onInfoWindowClose}
          onMapCenterChange={this.onMapCenterChange}
          onMapReady={this.onMapReady}
          onMarkerClick={this.onMarkerClick}
          onMarkerHover={this.onMarkerHover}
          onMarkerMouseOut={this.onMarkerMouseOut}
          providers={providers}
          selectedProvider={selectedProvider}
          showInfoWindow={showInfoWindow}
        />
        <Search
          enums={bootstrap.enums}
          google={google}
          map={map}
          onSubmit={this.onSearchSubmit}
          onToggleAdvancedFilters={this.onToggleAdvancedFilters}
          serviceTypes={serviceTypes}
          showAdvancedFilters={showAdvancedFilters}
        />
        <ProviderList
          hasSearched={hasSearched}
          loading={loading}
          onCardClick={this.onCardClick}
          onCardMouseEnter={this.onCardMouseEnter}
          onCardMouseLeave={this.onCardMouseLeave}
          paging={paging}
          providers={providers}
          selectedProvider={selectedProvider}
        />
        {
          showModal && (
            <ProviderModal
              onModalClose={this.onModalClose}
              provider={selectedProvider}
            />
          )
        }
      </div>
    );
  }
}

export default SearchWrapper;



// WEBPACK FOOTER //
// ./public/js/components/SearchWrapper/index.jsx